export default "__VITE_ASSET__nQMvwFBJ__"